export const DAY_MS = 24 * 60 * 60 * 1000;

// Start of the UTC day (00:00:00.000 UTC) the given epoch-ms timestamp falls in.
// Reporting timestamps are UTC end-to-end (see LB-4345), so day boundaries used to
// build/derive report periods must be computed in UTC, never the viewer's timezone.
export const startOfUtcDay = (ms: number): number => {
  const d = new Date(ms);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
};

// Last second of the UTC day (23:59:59) the given timestamp falls in.
export const endOfUtcDay = (ms: number): number => startOfUtcDay(ms) + DAY_MS - 1000;
